import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";
import {
  addDoc,
  getDoc,
  getDocs,
  deleteDoc,
  updateDoc,
  getFirestore,
  collection,
  doc,
  setDoc,
  query,
  where,
  Timestamp,
  writeBatch,
} from "firebase/firestore";
import { parse, subDays } from "date-fns";

const firebaseConfig = {
  apiKey: "AIzaSyBuaJwEif975gUZ1QXTLbmW9Xq8M1N8M-E",
  authDomain: "studio-pilates-zanardi.firebaseapp.com",
  databaseURL: "https://studio-pilates-zanardi-default-rtdb.firebaseio.com",
  projectId: "studio-pilates-zanardi",
  storageBucket: "studio-pilates-zanardi.appspot.com",
  messagingSenderId: "157230453177",
  appId: "1:157230453177:web:5b6de5e77b35e05be5a668",
  measurementId: "G-EPFEKZMEBB",
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);

const instructorsCollection = collection(db, "instructors");
const schedulesCollection = collection(db, "schedules");
const studentsCollection = collection(db, "students");
const classesCollection = collection(db, "classes");
const paymentCollection = collection(db, "payment");
const paymentValuesCollection = collection(db, "payment_values");

const attendanceCollection = collection(db, "attendance");

export async function requestLoginInstructor(email, password, navigate) {
  try {
    await signInWithEmailAndPassword(auth, email, password);
    localStorage.setItem("_id", email);
    navigate("/dashboard");
    return { status: "success" };
  } catch (err) {
    throw new Error("Email ou senha inválidos. Tente novamente.");
  }
}

export async function requestAddInstrutors(
  email,
  userName,
  password,
  phone,
  navigate
) {
  try {
    await createUserWithEmailAndPassword(auth, email, password);
    const docRef = doc(instructorsCollection, email);

    await setDoc(docRef, {
      userName: userName,
      id: email,
      phone: phone,
    });

    navigate("/");
    return { status: "success", message: "Document created successfully" };
  } catch (err) {
    throw new Error(err.message || "Falha ao criar conta.");
  }
}

export async function requestAddSchedules(email, schedules) {
  try {
    const docRef = doc(schedulesCollection, email);
    await setDoc(docRef, {
      id: email,
      schedules: schedules,
    });
    return { status: "success", message: "Document created successfully" };
  } catch (err) {
    return {
      status: "error",
      message: "Add schedules failed",
      error: err,
    };
  }
}

export async function deleteOldAbsences(email) {
  try {
    const cutoffDate = subDays(new Date(), 30);
    const cutoffTimestamp = Timestamp.fromDate(cutoffDate).seconds;

    const q = query(
      attendanceCollection,
      where("id", "==", email),
      where("timestamp", "<", cutoffTimestamp)
    );

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      console.log("Nenhum registro antigo para excluir.");
      return;
    }

    const batch = writeBatch(db);
    querySnapshot.docs.forEach((doc) => {
      batch.delete(doc.ref);
    });

    await batch.commit();

    console.log(
      `${querySnapshot.size} registros antigos foram excluídos com sucesso.`
    );
  } catch (err) {
    console.error("Erro ao excluir documentos antigos: ", err);
  }
}

export async function requestGetAbsenceList(email) {
  try {
    const endDate = new Date();
    const startDate = subDays(endDate, 30);

    const startTimestamp = Timestamp.fromDate(startDate).seconds;
    const endTimestamp = Timestamp.fromDate(endDate).seconds;

    const q = query(
      attendanceCollection,
      where("id", "==", email),
      where("timestamp", ">=", startTimestamp),
      where("timestamp", "<=", endTimestamp)
    );

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      console.log("Nenhum documento encontrado.");
      return [];
    }

    const attendanceData = querySnapshot.docs.reduce((acc, doc) => {
      const data = doc.data();
      const attendance = data.attendance;
      const timestamp = data.timestamp;

      if (attendance) {
        for (const [name, value] of Object.entries(attendance)) {
          if (value === false) {
            if (!acc[name]) {
              acc[name] = { count: 0, timestamps: [] };
            }
            acc[name].count += 1;
            acc[name].timestamps.push(timestamp);
          }
        }
      }
      return acc;
    }, {});

    const results = Object.entries(attendanceData).map(
      ([name, { count, timestamps }]) => ({
        name,
        absences: count,
        timestamps,
      })
    );

    return results;
  } catch (err) {
    console.error("Error getting documents: ", err);
    return [];
  }
}

export async function requestGetAttendanceList(email, date, setAttendance) {
  try {
    const parsedDate = parse(date, "dd-MM-yyyy", new Date());
    if (isNaN(parsedDate)) {
      throw new Error("Data inválida");
    }
    const timestamp = Timestamp.fromDate(parsedDate).seconds;
    const q = query(
      attendanceCollection,
      where("id", "==", email),
      where("timestamp", "==", timestamp)
    );

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      console.log("Nenhum documento encontrado.");
      setAttendance({});
      return [];
    }

    const results = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setAttendance(results[0].attendance);
    return results;
  } catch (err) {
    console.error("Error getting documents: ", err);
    return [];
  }
}

export async function requestAddAttendanceList(email, date, attendance) {
  try {
    const parsedDate = parse(date, "dd-MM-yyyy", new Date());
    if (isNaN(parsedDate)) {
      throw new Error("Data inválida");
    }
    const timestamp = Timestamp.fromDate(parsedDate).seconds;
    const docRef = doc(attendanceCollection, date);
    await setDoc(docRef, {
      id: email,
      attendance,
      timestamp: timestamp,
    });

    return { status: "success", message: "Document created successfully" };
  } catch (err) {
    return {
      status: "error",
      message: "Add attendance list failed",
      error: err,
    };
  }
}

export async function requestGetClasses(email, setMyClasses) {
  try {
    const docRef = doc(classesCollection, email);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const classesData = docSnap.data();
      setMyClasses(classesData.classes);
      return { status: "success", message: "Document get successfully" };
    } else {
      return {
        status: "error",
        message: "Classes not found",
      };
    }
  } catch (err) {
    return {
      status: "error",
      message: "Get classes failed",
      error: err,
    };
  }
}

export async function requestAddClasses(email, classes) {
  try {
    const docRef = doc(classesCollection, email);
    await setDoc(docRef, {
      id: email,
      classes: classes,
    });
    return {
      status: "success",
      message: "Document created successfully",
      id: docRef.id,
    };
  } catch (err) {
    return {
      status: "error",
      message: "Add classes failed",
      error: err,
    };
  }
}

export async function requestAddPayment(month, paymentData, email) {
  try {
    const docRef = doc(paymentCollection, month);
    await setDoc(docRef, {
      id: email,
      paymentData: paymentData,
      month: month,
    });
    return {
      status: "success",
      message: "Document created successfully",
      id: docRef.id,
    };
  } catch (err) {
    return {
      status: "error",
      message: "Add classes failed",
      error: err,
    };
  }
}

export async function requestSavePaymentValues(paymentValues) {
  try {
    const docRef = doc(paymentValuesCollection, "payment_values");
    await setDoc(docRef, {
      one_class: paymentValues[0],
      two_class: paymentValues[1],
      three_class: paymentValues[2],
    });
    return {
      status: "success",
      message: "Document created successfully",
      id: docRef.id,
    };
  } catch (err) {
    return {
      status: "error",
      message: "Add classes failed",
      error: err,
    };
  }
}

export async function requestGetPaymentValues(setPaymentValues) {
  try {
    const docRef = doc(paymentValuesCollection, "payment_values");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setPaymentValues([
        docSnap.data().one_class,
        docSnap.data().two_class,
        docSnap.data().three_class,
      ]);
      return {
        status: "success",
        message: "Document retrieved successfully",
      };
    } else {
      setPaymentValues([]);
      return {
        status: "error",
        message: "No such document!",
      };
    }
  } catch (err) {
    return {
      status: "error",
      message: "Failed to retrieve payment",
      error: err,
    };
  }
}

export async function requestGetPayment(month, setPaymentData) {
  try {
    const docRef = doc(paymentCollection, month);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setPaymentData({
        paymentData: docSnap.data().paymentData,
        month: docSnap.data().month,
      });
      return {
        status: "success",
        message: "Document retrieved successfully",
      };
    } else {
      setPaymentData([]);
      return {
        status: "error",
        message: "No such document!",
      };
    }
  } catch (err) {
    return {
      status: "error",
      message: "Failed to retrieve payment",
      error: err,
    };
  }
}

export async function requestGetAllPayments(setAllPaymentsData) {
  try {
    const querySnapshot = await getDocs(paymentCollection);
    const results = querySnapshot.docs.map((doc) => doc.data());
    setAllPaymentsData(results);
    return { status: "success", data: results };
  } catch (err) {
    console.error("Failed to retrieve all payments", err);
    return { status: "error", error: err };
  }
}

export async function requestAddStudent(name, phone) {
  try {
    const docRef = await addDoc(studentsCollection, {
      name: name,
      phone: phone,
      lastEvaluationDate: null,
    });

    return {
      status: "success",
      message: "Document created successfully",
      id: docRef.id,
    };
  } catch (err) {
    return {
      status: "error",
      message: "Add student failed",
      error: err,
    };
  }
}

export async function requestDeleteStudent(id) {
  try {
    const studentDocRef = doc(studentsCollection, id);
    await deleteDoc(studentDocRef);

    return {
      status: "success",
      message: "Estudante deletado com sucesso!",
    };
  } catch (error) {
    console.error("Erro ao deletar estudante:", error);
    return {
      status: "error",
      message: error.message,
    };
  }
}

export async function requestUpdateStudent(id, name, phone) {
  try {
    const studentDoc = doc(studentsCollection, id);
    await updateDoc(studentDoc, {
      name: name,
      phone: phone,
    });

    return { status: "success", message: "Student updated successfully" };
  } catch (err) {
    return {
      status: "error",
      message: "Failed to update student",
      error: err,
    };
  }
}

export async function requestGetStudents() {
  try {
    const querySnapshot = await getDocs(studentsCollection);
    const students = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    return { status: "success", data: students };
  } catch (err) {
    return {
      status: "error",
      message: "Failed to retrieve students",
      error: err,
    };
  }
}

export async function requestGetStudentByPhone(phone) {
  try {
    const q = query(studentsCollection, where("phone", "==", phone));
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return {
        status: "error",
        message: "Nenhum aluno encontrado com este telefone.",
      };
    } else {
      const studentDoc = querySnapshot.docs[0];

      return {
        status: "success",
        data: {
          id: studentDoc.id,
          name: studentDoc.data().name,
          phone: studentDoc.data().phone,
        },
      };
    }
  } catch (error) {
    console.error("Erro ao buscar aluno por telefone:", error);
    return {
      status: "error",
      message: "Ocorreu um erro no servidor ao buscar o aluno.",
    };
  }
}

export async function requestGetSchedules(email, setSchedules) {
  try {
    const docRef = doc(schedulesCollection, email);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const schedulesData = docSnap.data();
      setSchedules(schedulesData.schedules);
      return { status: "success", message: "Document get successfully" };
    } else {
      return {
        status: "error",
        message: "Schedules not found",
      };
    }
  } catch (err) {
    return {
      status: "error",
      message: "Get schedules failed",
      error: err,
    };
  }
}

export async function requestSaveEvaluation(studentId, evaluationData) {
  try {
    const batch = writeBatch(db);
    const now = Timestamp.now();

    const newEvaluationRef = doc(
      collection(db, "students", studentId, "evaluations")
    );

    batch.set(newEvaluationRef, {
      ...evaluationData,
      createdAt: now,
    });

    const studentRef = doc(db, "students", studentId);

    batch.update(studentRef, {
      lastEvaluationDate: now,
    });

    await batch.commit();

    return {
      status: "success",
      message: "Avaliação salva e aluno atualizado com sucesso!",
      id: newEvaluationRef.id,
    };
  } catch (err) {
    console.error("Erro ao salvar a avaliação e atualizar o aluno:", err);
    return {
      status: "error",
      message: "Falha ao salvar a avaliação.",
      error: err,
    };
  }
}

export async function requestGetEvaluationHistory(studentId) {
  try {
    const studentEvaluationsCollection = collection(
      db,
      "students",
      studentId,
      "evaluations"
    );

    const querySnapshot = await getDocs(studentEvaluationsCollection);

    const history = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return { status: "success", data: history };
  } catch (err) {
    console.error("Erro ao buscar o histórico de avaliações:", err);
    return {
      status: "error",
      message: "Falha ao buscar o histórico de avaliações.",
      error: err,
    };
  }
}

export async function getStudentsNotEvaluatedThisMonth() {
  try {
    const now = new Date();
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const startTimestamp = Timestamp.fromDate(startOfMonth);

    const studentsCollection = collection(db, "students");
    const unevaluatedStudents = [];

    const qEvaluatedBefore = query(
      studentsCollection,
      where("lastEvaluationDate", "<", startTimestamp)
    );

    const qNeverEvaluated = query(
      studentsCollection,
      where("lastEvaluationDate", "==", null)
    );

    const [evaluatedBeforeSnapshot, neverEvaluatedSnapshot] = await Promise.all(
      [getDocs(qEvaluatedBefore), getDocs(qNeverEvaluated)]
    );

    evaluatedBeforeSnapshot.forEach((doc) => {
      unevaluatedStudents.push({
        id: doc.id,
        ...doc.data(),
      });
    });

    neverEvaluatedSnapshot.forEach((doc) => {
      unevaluatedStudents.push({
        id: doc.id,
        ...doc.data(),
      });
    });

    return { status: "success", data: unevaluatedStudents };
  } catch (err) {
    console.error("Erro ao buscar estudantes não avaliados (otimizado):", err);
    return {
      status: "error",
      message: "Falha ao buscar estudantes não avaliados.",
      error: err,
    };
  }
}

export async function requestDeleteEvaluation(studentId, evaluationId) {
  try {
    const evaluationDocRef = doc(
      db,
      "students",
      studentId,
      "evaluations",
      evaluationId
    );

    await deleteDoc(evaluationDocRef);

    return {
      status: "success",
      message: "Avaliação deletada com sucesso!",
    };
  } catch (err) {
    console.error("Erro ao deletar a avaliação:", err);
    return {
      status: "error",
      message: "Falha ao deletar a avaliação.",
      error: err,
    };
  }
}

export async function requestGetStudentById(studentId) {
  try {
    const studentDocRef = doc(db, "students", studentId);
    const docSnap = await getDoc(studentDocRef);

    if (docSnap.exists()) {
      return { status: "success", data: docSnap.data() };
    } else {
      return { status: "error", message: "Student not found" };
    }
  } catch (err) {
    return {
      status: "error",
      message: "Failed to retrieve student",
      error: err,
    };
  }
}
